import App from '@/App.vue';
import { dxLicenseKey } from '@/helpers/appConfig';
import { pageTitle } from '@/helpers/pageTitle';
import { routeGuard } from '@/helpers/routeGuard';
import { i18n } from '@/i18n';
import { followOtherTabs } from '@/helpers/sessionHelpers';
import RoleDirective from '@/helpers/directives/roleDirective';
import { createSignalR } from '@/services/signalr';
import config from 'devextreme/core/config';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { routes } from 'vue-router/auto-routes';

config({ licenseKey: dxLicenseKey });

export const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach(routeGuard);
router.afterEach(to => {
    document.title = pageTitle(to.meta.title);
});

const app = createApp(App)
    .use(createPinia())
    .use(i18n)
    .use(router)
    .use(createSignalR());

app.directive('role', RoleDirective);
// Another tab's login, logout or token refresh changes the shared token.
window.addEventListener('storage', followOtherTabs);

app.mount('#app');
